import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.45);
`;

const Card = styled.div`
  width: 100%;
  max-width: 320px;
  padding: 20px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.25);
  font-family: inherit;
`;

const Title = styled.h2`
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 700;
  color: #1b3c66;
`;

const Body = styled.p`
  margin: 0 0 18px;
  font-size: 13.5px;
  line-height: 1.45;
  color: #475569;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

const Button = styled.button`
  padding: 8px 14px;
  border-radius: 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid ${props => (props.primary ? 'transparent' : '#cbd5e1')};
  background: ${props => (props.primary
    ? 'linear-gradient(135deg, #3b74b8 0%, #275386 55%, #1b3c66 100%)'
    : '#ffffff')};
  color: ${props => (props.primary ? '#ffffff' : '#1b3c66')};
`;

// In-widget confirmation, used instead of the browser's confirm() popup
const ConfirmDialog = ({ open, title, message, confirmLabel, cancelLabel, onConfirm, onCancel }) => {
  const cancelRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    cancelRef.current?.focus();  // the safe choice has focus
    const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onCancel]);

  if (!open) return null;
  return (
    <Overlay onClick={onCancel}>
      <Card role="alertdialog" aria-modal="true" aria-labelledby="confirm-title"
            onClick={(e) => e.stopPropagation()}>
        <Title id="confirm-title">{title}</Title>
        <Body>{message}</Body>
        <Actions>
          <Button ref={cancelRef} type="button" onClick={onCancel}>{cancelLabel}</Button>
          <Button primary type="button" onClick={onConfirm}>{confirmLabel}</Button>
        </Actions>
      </Card>
    </Overlay>
  );
};

export default ConfirmDialog;
